import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Lift } from '@models/lift.model';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PagedResponse } from "@models/response.model";
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ContextMenuComponent } from '@app/shared/components/context-menu/context-menu.component';

@Component({
    selector: 'app-lift-list',
    templateUrl: './lift-list.component.html',
    styleUrls: ['./lift-list.component.scss']
})
export class LiftListComponent implements OnInit {
    @ViewChild('liftContextMenu', {static: true}) liftContextMenu: ContextMenuComponent;
    @Input() items: PagedResponse<any> = new PagedResponse<any>();
    @Input() config: TableConfig;

    @Output() selectLift = new EventEmitter<any>();
    @Output() reachEnd = new EventEmitter<any>();
    @Output() openLiftInNewTab = new EventEmitter<Lift>();

    contextMenuItems: MenuItem[] = [];

    form: UntypedFormGroup;

    constructor(public formBuilder: UntypedFormBuilder, private translate: TranslateService) {
    }

    ngOnInit() {
    }

    @HostBinding('class.no-items') hasItems() {
        return this.items && this.items.items && this.items.items.length > 0;
    }

    onSelectLiftClick(lift: Lift) {
        this.selectLift.emit(lift);
    }

    onLiftContextMenu(event: MouseEvent, lift: Lift) {
        event.preventDefault();
        this.contextMenuItems = [{
            label: this.translate.instant('generic.buttons.openNewTab'),
            icon: 'fa fa-external-link',
            command: () => this.openLiftInNewTab.emit(lift)
        }];
        this.liftContextMenu.show(event);
    }

    onEnd(event) {
        if (event.endIndex !== this.items.items.length - 1) {
            return;
        }
        if (this.items.items.length >= this.items.total) {
            return;
        }
        this.reachEnd.emit(this.config);
    }
}
